<template>
    <div class="drawMoney">
        <ul class="outList" ref="changeOutList"
            v-infinite-scroll="loadMoreOut"
            infinite-scroll-disabled="loadingOut"
            infinite-scroll-distance="5"
        >
            <li
                v-for="outBill in outBills"
                :key="outBill.id"
            >
                <div class="item">
                    <p class="itemTitle">{{outBill.type}}</p>
                    <p class="itemTime">{{outBill.timeline}}</p>
                </div>
                <span :class="['number', (outBill.moneytype == '-' ? 'active' : '')]">{{outBill.moneytype}} {{outBill.money}}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import {Toast} from 'mint-ui';

export default {
    components:{
        
    },
    data(){
        return {
            outBills:[],
            pageOut:1,
            loadingOut:false,
            hasMoreOut:false,
        }
    },
    methods:{
        loadMoreOut(){
            const _this = this;
            if(_this.hasMoreOut){
                _this.loadingOut = true
                Toast({
                    message: '没有更多数据了',
                    position: 'bottom',
                })
                return false
            }
            _this.loadingOut = true
            function setupWebViewJavascriptBridge(callback) {                                            
                if (window.WebViewJavascriptBridge) { 
                    return callback(WebViewJavascriptBridge); 
                }
                if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }              
                window.WVJBCallbacks = [callback];                                                        
                var WVJBIframe = document.createElement('iframe');                                        
                WVJBIframe.style.display = 'none';                                                        
                WVJBIframe.src = 'https://__bridge_loaded__';                                             
                document.documentElement.appendChild(WVJBIframe);                                                
                setTimeout(function() { 
                    document.documentElement.removeChild(WVJBIframe) 
                }, 0)                  
            }                                                                                                      
            setupWebViewJavascriptBridge(function(bridge) {
                bridge.callHandler('encrypt', {
                    uid : localStorage.getItem("UID"),
                    page: _this.pageOut,
                    token : localStorage.getItem("UserToken"),
                    // page: 1,
                    request_time : Date.parse(new Date())
                }, function(response) {        //加密获取到的数据 
                    let userInfoCode = response.dataReq
                    let userInfoSign = response.dataSign
                    _this.$axios.post("/api/user/widthdrawlog", {      
                        code : userInfoCode,
                        dataSign : userInfoSign,
                    }).then(res=>{       //发送给后端加密数据 code和md5值，同时获取后端api的加密数据
                        if(res.data.msg == '页面超时，请返回首页'){
                            alert(res.data.msg);
                            _this.$router.push({path:"/home"})
                            return;
                        }
                        console.log("res", res.data)
                        bridge.callHandler('decrpt', {
                            dataReq : res.data.dataReq,
                            dataSign : res.data.dataSign,
                        }, function(response) {  
                            console.log("解密", response)
                            // ios解密   赋值   渲染
                            _this.loadingOut = false
                            _this.outBills = _this.outBills.concat(response.info.list)
                            console.log("体现", _this.outBills)
                            if(response.info.list.length === 0){
                                _this.hasMoreOut = true
                                return false
                            }else{
                                _this.pageOut++
                            }
                            
                        })
                    })
                })
            })
        },
    }
}
</script>
<style lang="scss" scoped>
    .incomeList,.outList{
            li{
                width:100%;
                height:.70rem;
                display:flex;
                justify-content: space-between;
                align-items: center;
                .item{
                    width:2.40rem;
                    .itemTitle{
                        color:#222527;
                        font-size: .14rem;
                    }
                    .itemTime{
                        font-size: .12rem;
                        color:#9B9B9B;
                    }
                }
                .number{
                    font-size: .18rem;
                    color:#30D2AE;
                }
                .active{
                    color:#FF5A55;  
                }
            }
        }
</style>
